<template>
    <div class="form">
        <h4 class="step-title">
            How many drivers do you want to insure?
        </h4>
        <div class="step-content d-flex flex-column flex-md-row align-items-center">
            <button-list v-bind:items="driverCounts" v-bind:onclick="complete"></button-list>
        </div>
    </div>
</template>

<script>
    import ButtonList from "./shared/ButtonList.vue"

    export default {
        name: "NumberOfDrivers",
        components: {
            ButtonList
        },
        data: function() {
            return {
                driverCounts: [
                    { text: "1", value: 1 },
                    { text: "2", value: 2 },
                    { text: "3+", value: 3 }
                ]
            }
        },
        props: {
            lead: Object
        },
        methods: {
            complete: function(numberOfDrivers) {
                this.lead.numberOfDrivers = numberOfDrivers;
                this.$emit("complete", this.$options.name, numberOfDrivers);
            }
        }
    }
</script>
